import type { GlobalAssistantContextPolicy } from './global-ai-assistant-api';
import type { GlobalAssistantBoundedConversationContext } from './global-ai-assistant-conversation';

export function toConversationPayload(
  context: GlobalAssistantBoundedConversationContext
):
  | {
      turns: GlobalAssistantBoundedConversationContext['turns'];
      summary?: string;
    }
  | undefined {
  if (context.turns.length === 0 && !context.summary) {
    return undefined;
  }
  return {
    turns: context.turns,
    ...(context.summary ? { summary: context.summary } : {}),
  };
}

export function applyConversationPolicy(args: {
  policy: GlobalAssistantContextPolicy;
  fullConversation: GlobalAssistantBoundedConversationContext;
}): GlobalAssistantBoundedConversationContext {
  const { policy, fullConversation } = args;
  if (policy === 'recent_only') {
    return { turns: fullConversation.turns };
  }
  if (policy === 'none') {
    return { turns: [] };
  }
  return fullConversation;
}

export function resolveFollowOnContextPolicy(
  requestedPolicy: GlobalAssistantContextPolicy | undefined
): GlobalAssistantContextPolicy {
  if (
    requestedPolicy !== 'full' &&
    requestedPolicy !== 'recent_only' &&
    requestedPolicy !== 'none'
  ) {
    return 'full';
  }
  return requestedPolicy;
}
